import { Suspense, useRef, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
import * as THREE from 'three';
import ZoneFloor from './ZoneFloor';
import AgentLayer from './AgentLayer';

function SceneContents() {
  const controlsRef = useRef();

  useEffect(() => {
    if (controlsRef.current) {
      window.__orbitControls = controlsRef.current;
    }
  }, []);

  return (
    <>
      <PerspectiveCamera makeDefault position={[16, 20, 16]} fov={52} />
      <OrbitControls
        ref={controlsRef}
        target={[0, 0, 0]}
        enablePan
        enableZoom
        minDistance={10}
        maxDistance={40}
        maxPolarAngle={Math.PI / 2.4}
        mouseButtons={{
          LEFT: null,
          MIDDLE: THREE.MOUSE.PAN,
          RIGHT: THREE.MOUSE.ROTATE,
        }}
      />

      <color attach="background" args={['#090b12']} />
      <fog attach="fog" args={['#090b12', 35, 65]} />

      <ambientLight intensity={0.4} />
      <directionalLight
        position={[10, 18, 8]}
        intensity={1.2}
        castShadow
      />
      <pointLight position={[0, 6, 0]} color="#00ffcc" intensity={1.2} />
      <pointLight position={[0, 4, 0]} color="#8b5cf6" intensity={0.8} />

      <ZoneFloor />
      <Suspense fallback={null}>
        <AgentLayer />
      </Suspense>
    </>
  );
}

export default function WorldScene() {
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Canvas shadows={{ type: THREE.PCFShadowMap }}>
        <SceneContents />
      </Canvas>
    </div>
  );
}
